import { createReducer, on } from '@ngrx/store';
import { ApiDataSection } from '../../interfaces';
import { getSectionsSuccess } from './api-data.actions';

export const apiDataFeatureKey: string = 'api-data';

export interface ApiDataState {
  sections: ApiDataSection[];
}

export const initialState: ApiDataState = {
  sections: [],
};

export const apiDataReducer = createReducer(
  initialState,
  on(getSectionsSuccess, (state: ApiDataState, { sections }) => ({
    ...state,
    sections
  }))
);
